import React from 'react';
import { Classes } from '@blueprintjs/core';
import NumberFormat from 'react-number-format';
import { formatSingleNumber } from '../formatNumber/FormatNumber';
import { Suffixes } from './suffixes';
const defaultNumberProps = {
    thousandSeparator: ' ',
    decimalSeparator: ',',
    allowedDecimalSeparators: [',', '.'],
    decimalScale: 2,
};
export const NumberInput = (props) => {
    return React.createElement(NumberFormat, Object.assign({ className: Classes.INPUT }, defaultNumberProps, props));
};
export const NumberText = (props) => {
    // @ts-ignore
    const numberValue = Math.abs(props.value);
    const computeSuffix = () => {
        if (numberValue > 1) {
            return props.suffix;
        }
        if (props.suffix === Suffixes.ANS) {
            return Suffixes.AN;
        }
        return props.suffix;
    };
    const propertyVal = props.value
        ? typeof props.value === 'number'
            ? props.value.toFixed(2).toString()
            : props.value.toString()
        : '';
    return (React.createElement(NumberFormat, Object.assign({ displayType: 'text' }, defaultNumberProps, props, { suffix: computeSuffix(), value: formatSingleNumber(propertyVal, 2) })));
};
//# sourceMappingURL=NumberInput.js.map